export default __webpack_public_path__ + "static/harmonious-carousel-mobile-panel1-3e8a43993bf6ea745b3260e7a95a40dbbf6860bc1d90e678410f3adec5afe556.png";